import { combineReducers } from "redux";
import ui from "./uiReducer";
import documents from "./documentsReducer";

export default combineReducers({
  ui,
  entities: documents
});
